import styled from 'styled-components';
import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import Title from './Title';
import SubTitle from './SubTitle';

import Button from '../../components/Button';
import { Link } from '../Link';

import FacebookLogo from '../../images/Blog/logo_facebook.svg';
import LinkedInLogo from '../../images/Blog/logo_linkedin.svg';
import TwitterLogo from '../../images/Blog/logo_twitter.svg';
import WhatsappLogo from '../../images/Blog/logo_whatsapp.svg';

import moment from 'moment';
import 'moment/locale/pt-br';
import LazyImage from '../LazyLoadImage';

const DescriptionStyle = styled.p`
  color: ${(props) => (props.color ? props.color : props.theme.colors.gray)};
  font-family: 'Lato', sans-serif;
  font-size: ${(props) => (props.fontSize ? props.fontSize : '1rem')};
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: 0.5px;
  padding: 1rem 0 0 0;
  margin: ${(props) => (props.margin ? props.margin : '')};

  width: 100%;
  position: relative;
  transition: all 1s ease;
  left: 0;
  bottom: 0;

  @media (max-width: 1440px) {
    font-size: 0.9rem;
    line-height: 1.3rem;
  }
`;

const MoreInfo = styled.div`
  position: absolute;
  left: -300em;
  transition: all 0.3s ease;
  bottom: 0;
  top: 0;
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  p {
    font-family: 'Lato', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.51px;
    color: ${({ theme }) => theme.colors.gray};
    margin-top: 1em;
  }

  ul {
    list-style: none;
    margin-top: 1em;
    li {
      display: inline;
    }
  }

  .logo-links {
    cursor: pointer;
    margin-right: 1em;
  }
`;

export const CardStyle = styled.div`
  ${(props) => (props.equalHeight ? 'height: 100%;' : null)}
  background-color: white;
  z-index: 1111;
  overflow: visible;
  margin: ${(props) => (props.margin ? props.margin : '')};
  padding: ${(props) => (props.padding ? props.padding : '')};
  transition: all linear 0.3s;
  ${(props) => (props.BorderTopRight ? `border-radius: 0px 38px 0px 0px` : ``)};
  ${(props) => (props.BorderTopLeft ? `border-radius: 38px 0px 0px 0px` : ``)};
  ${(props) => (props.BorderBottomLeft ? `border-radius: 0px 0px 0px 38px` : ``)};
  ${(props) => (props.BorderBottomRight ? `border-radius: 0px 0px 38px 0px` : ``)};

  -webkit-box-shadow: 24px 36px 58px 0px rgba(77, 80, 98, 0.15);
  -moz-box-shadow: 24px 36px 58px 0px rgba(77, 80, 98, 0.15);
  box-shadow: 24px 36px 58px 0px rgba(77, 80, 98, 0.15);
  &:hover {
    -webkit-box-shadow: 36px 48px 64px 0px rgba(77, 80, 98, 0.4);
    -moz-box-shadow: 36px 48px 64px 0px rgba(77, 80, 98, 0.4);
    box-shadow: 36px 48px 64px 0px rgba(77, 80, 98, 0.4);

    .card-title {
      border-bottom: 1px solid ${({ theme }) => theme.colors.green};
    }
  }

  &:hover ${DescriptionStyle} {
    left: 300em;
    display: none;
  }

  &:hover ${MoreInfo} {
    left: 0;
    right: 0;
  }

  &:hover .secondary-content {
    min-height: 180px;
  }

  &:hover .more-info {
    position: relative;
  }
`;

const CardInfo = styled.div`
  width: 85%;
  margin: 2rem auto;
  padding: 0;
  overflow: hidden;
  padding-bottom: 40px;

  .secondary-content {
    position: relative;
  }

  a {
    text-decoration: none;

    &:hover {
      opacity: 0.5;
      color: red;
    }
  }
`;
const CardImage = styled.div`
  background-color: transparent;

  img {
    max-width: 100%;
    width: 100%;
    -moz-transition: all 0.3s;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    cursor: pointer;

    ${(props) => (props.BorderTopRight ? `border-radius: 0px 38px 0px 0px` : ``)};
    ${(props) => (props.BorderTopLeft ? `border-radius: 38px 0px 0px 0px` : ``)};
  }
`;

const Card = (props) => (
  <CardStyle {...props}>
    <CardImage {...props}>
      <Link to={props.link}>
        <LazyImage imageData={props.SrcImageTop} alt={props.ImageAltText} />
      </Link>
    </CardImage>
    <CardInfo>
      <SubTitle category={props.SubTitleRightText}>
        <p>{moment(props.SubTitleLeftText, 'LL').locale('pt-BR').format('DD, MMMM, YYYY')}</p>
      </SubTitle>
      <Link to={props.link}>
        <Title>{props.Title}</Title>
      </Link>
      <div className="secondary-content">
        <DescriptionStyle>{props.Description}</DescriptionStyle>
        <MoreInfo className="more-info">
          <Link to={props.link}>
            <Button color="purple" withArrow>
              Ler notícia completa
            </Button>
          </Link>
          <p>Compartilhe esse conteúdo</p>
          <ul>
            <li>
              <a
                className="logo-links"
                href={`https://www.facebook.com/sharer/sharer.php?u=https://pagar.me${props.link}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={FacebookLogo} alt="logo" />
              </a>
            </li>
            <li>
              <a
                className="logo-links"
                href={`http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                  `https://pagar.me${props.link}`,
                )}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={LinkedInLogo} alt="logo" />
              </a>
            </li>
            <li>
              <a
                className="logo-links"
                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                  `https://pagar.me${props.link}`,
                )}&text=${props.Title}&via=Pagar_me`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={TwitterLogo} alt="logo" />
              </a>
            </li>
            <li>
              <a
                className="logo-links"
                href={`https://web.whatsapp.com/send?text=https://pagar.me${props.link}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={WhatsappLogo} alt="logo" />
              </a>
            </li>
          </ul>
        </MoreInfo>
      </div>
    </CardInfo>
  </CardStyle>
);

export default Card;
